import { render } from "./solution.vue?vue&type=template&id=0470020c&scoped=true"
import script from "./solution.vue?vue&type=script&lang=js"
export * from "./solution.vue?vue&type=script&lang=js"

import "./solution.vue?vue&type=style&index=0&id=0470020c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0470020c"

export default script